import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUserAccount, selectUserType } from '@/features/domain/user'
import { RmAccountFormValues } from '../../types'

export function useAccountData() {
  const account = useSelector(selectUserAccount)
  const userType = useSelector(selectUserType)

  const accountData = useMemo<RmAccountFormValues>(() => {
    return {
      name: account.details.name,
      email: account.details.email,
      surname: account.details.surname,
      username: account.credentials.username.trim(),
    }
  }, [account])

  const gotAccessToApiKey = userType === 'admin'

  return {
    accountData,
    gotAccessToApiKey,
  }
}
